<div class="privacy-policy">
<span class="document-title">Privacy Policy</span>

<div class="section-header">
<p>
    This Agilysys Reserve Privacy Policy (
    <strong>“Policy”</strong>
    ) describes the practices Agilysys Reserve NV, LLC, a Delaware limited liability company (
    <strong>“Agilysys Reserve,” “we,” “our,”</strong>
    or
    <strong>“us”</strong>
    ), observes when collecting, using, and sharing data and other information through our Agilysys Reserve offering (
    <strong>“Information”</strong>
    ).
</p>
<p>
    We offer our Agilysys Reserve services (
    <strong>“Services”</strong>
    ) on behalf of restaurants and other businesses that choose to sign-up with Agilysys Reserve for our Services (our
    <strong>“Customers”</strong>
    ). Our Services enable our Customers to provide their customers with various online and mobile reservation services.
    By using the Services we provide on behalf of any of our Customers, you become a user of our Services (a
    <strong>“User”</strong>
    ).
</p>
You and other Users may access our Services via:
<ul>
    <li>
        The Agilysys Reserve software widgets included on websites of our Customers (our
        <strong>“Widgets”</strong>
        ); and
    </li>
    <li>
        The Agilysys Reserve software applications for phones, tablets, and other mobile devices provided by Agilysys Reserve and on
        behalf of our Customers (our
        <strong>“Applications”</strong>
        ); and
    </li>
    <li>
        Any User-facing Agilysys Reserve websites where we display this Policy (our
        <strong>“Sites”</strong>
        ).
    </li>
</ul>
<p>
    By using our Widgets, Applications, or Sites (our
    <strong>“Platform”</strong>
    ) you consent to the collection and use of your Information by rGuest as described in this Policy.
    If you have any questions or concerns regarding this Policy or the Information collection, usage, or sharing
    practices applicable to the Platform under this Policy, please contact us at privacy@Agilysys.com. If we need, or
    are required, to contact you concerning any event that involves this Policy, your Information, or our Platform we
    may do so using the email address, telephone number, or physical mail address we have on file for you.
</p>
<div class="page-title">Summary.</div>
<p>Although we encourage you to read this entire Policy, this is a summary of some of the more important aspects of the
    Policy:</p>
<ul>
    <li>This Policy is applicable only to Information collected by and on behalf of rGuest through our own Platform.
        This Policy does not apply to Information collected by our Customers or by other third parties outside of our
        Platform.</li>
    <li>We may collect both Non-Personal Information and Personal Information from you through our Platform. The
        Personal Information we obtain from you may also include Sensitive Personal Information.</li>
    <li>We will not use or share your Personal Information (including Sensitive Personal Information) except as
        permitted by this Policy.</li>
    <li>You are permitted to “opt out” of certain uses of your Personal Information under this Policy.</li>
    <li>We will take reasonable and appropriate measures to secure your Personal Information, but we make no promise
        that your Personal Information will remain secure in all circumstances.</li>
</ul>
<div class="page-title">Scope of this Policy.</div>
<p>
    Our Platform enables Users to access and use the Services we offer on behalf of our Customers in a variety of ways.
    We may offer our Services through our own Sites bearing the rGuest name. We also offer our Services through the
    websites of our Customers (
    <strong>“Customer Sites”</strong>
    ) by way of our Widget. Our Widget is a small software application that is actually included within Customer Sites
    enabling us to offer our Services through those Customer Sites. In addition, while we may offer our Services through
    our own Application, we may also offer our Services through Applications we provide on behalf of our Customers (
    <strong>“Customer Applications”</strong>
    ). These Customer Applications may be provided either under the rGuest name or the name of our Customer. They may
    also be listed as “powered by” Agilysys Reserve.
</p>
<p style='text-transform: uppercase;'>This Policy covers only Information collected through our Platform. It does not
    cover Information collected through Customer Sites, CUSTOMER Applications, OR ANY THIRD PARTY WEBSITES OR
    APPLICATIONS. when you leave our Platform and use any Customer Site OR CUSTOMER Application, this Policy does not
    apply.</p>
<p>When you use the Platform to interact with our Customers, other Users, or third parties, you may share your
    Information with us or with those Customers, other Users, and third parties. You consent to rGuest facilitating the
    sharing of your Information with those Customers, other Users and third parties as you direct through the Platform
    in accordance with this Policy.</p>
<p>We are not responsible for the privacy practices of our Customers, other Users, or third parties. For information
    about what terms may apply to any Information you share with any of our Customers through any Customer Sites or
    Customer Applications, or with any third party through other websites or applications, please contact the Customer
    or the other third party directly before providing them with Your Information.</p>
<div class="page-title">Types of Information We Collect Through our Platform.</div>
<p>The Information we collect about you through our Platform includes both “non-personal” and “personal” Information. We
    may also obtain “sensitive” personal information about you through our Platform. For purposes of this Policy:</p>
<p>
    <strong>“Non-Personal Information”</strong>
    refers to information that may not by itself be reasonably associated with, linked to, or used to identify you. For
    example, non user-specific Information regarding your use of the Platform or the operation of the Platform.
</p>
<p>
    <strong>“Personal Information”</strong>
    refers to information that may be reasonably associated with or linked specifically to you or reasonably allow you
    to be personally identified or contacted. For example, Personal Information may include information such as your
    first and last name and in certain circumstances your email address, telephone number, or street address, either
    alone or in combination with other Information.
</p>
<p>
    <strong>“Sensitive Personal Information”</strong>
    refers to Personal Information regarding more sensitive areas such as your credit card and certain other financial
    information or your precise geolocation information.
</p>
<div class="page-title">Sources of Information.</div>
<p>We may collect Information about you through the Platform from a variety of sources, for example:</p>
<p>
    <strong>Directly from You.</strong>
    We may collect Information about you directly from you when you voluntarily provide it to us through our Platform.
    For example, through placing a reservation with one of our Customer’s through our Platform or communicating with us,
    our Customers, or other Users through our Platform. We may use any Information you provide to us through the
    Platform in accordance with this Policy.
</p>
<p>
    <strong>From Other Users.</strong>
    We may receive Information about you from other Users when they provide Information through our Platform. For
    example, when they communicate with you or with us through our Platform. We may use any Information about you other
    Users provide through the Platform in accordance with this Policy.
</p>
<p>
    <strong>From Our Customers.</strong>
    We may obtain Information about you from our Customers based on your interactions with those Customers. For example,
    if you place a reservation with one of our Customers and they collect Information regarding your experience at their
    restaurant. We may use any Information about you that we obtain from our other Customers in accordance with this
    Policy.
</p>
<p>
    <strong>From Our Vendors.</strong>
    We may obtain Information about you from the third party vendors that provide services to us. For example, if we
    rely on third party services to facilitate emails or other messages sent through our Platform, we may receive
    Information about you from those third-parties. We may use any Information about you that we obtain from our third
    party vendors in accordance with this Policy.
</p>
<p>
    <strong>From Other Third Parties.</strong>
    We may obtain Information about you from third parties that have obtained or collected Information about you and
    that have the right to provide that Information to us. For example, we may contract with third parties that collect
    or obtain information about you or to verify certain information about you. We may use any Information about you we
    obtain from these third parties in accordance with the contractual terms we establish with those third parties. Only
    if we combine that Personal Information with Information we collect from you under this Policy, will we be required
    to use that Personal Information in accordance with this Policy as well.
</p>
<p>
    <strong>From Our Affiliates, Subsidiaries, and Business Units.</strong>
    We may obtain Information about you from our affiliates and subsidiaries, including companies that we own or
    control, that own or control us, or that are under common ownership or control with us, regardless of whether these
    entities share the rGuest brand. We may also obtain Information about you from other business units that also offer
    websites, applications, or services under the rGuest brand or one of our other brands. We may use any Information
    about you that we obtain from our affiliates, subsidiaries or business units in accordance with the terms under
    which that Information was collected by that affiliate, subsidiary or business unit. If we combine that Information
    with Information we collect under this Policy, then we will use that combined Information in accordance with this
    Policy as well.
</p>
<p>
    <strong>Through the Operation of the Platform.</strong>
    We may collect Information about you automatically when you interact with the Platform. For example, we and service
    providers may use “cookies,” “web beacons,” and other automated tracking technology to monitor and collect
    Information regarding how you access, use, and interact with the Platform. “Cookies” are commonly used small files
    that are stored on your computer or mobile device to help identify you as a unique user of the Platform. “Web
    beacons” (also known as “single–pixel” or “clear” GIFs) include electronic images imbedded in the Platform that
    allow us to recognize when you visit that area of the Platform.
</p>
<p>We and our third party service providers may use cookies, web beacons, and other tracking technology that expire once
    you close your browser or log out of the Platform. We may also use technologies that persist and stay on your
    computer until you delete them. Most browsers will allow you to erase cookies from your computer or mobile device,
    block acceptance of cookies, or receive a warning before a cookie is stored. You may also be able to refuse certain
    web beacons by adjusting the settings on your browser or email software. Please refer to your browser or email
    software instructions or help screen to learn more about these functions.</p>
<p>The computers we use to provide the Platform may also automatically record Information about you. For example, our
    web servers may record the Information you enter on the Platform, the areas of the Platform you visit, the services
    you use through the Platform, your IP address, or cookies that are set on your browser. We may use any Information
    we collect from you automatically through the Platform in accordance with this Policy.</p>
<p>Please note that our third party providers also use cookies, web beacons, or other tracking technologies in messages
    displayed on or communicated through the Platform. We do not have access to information that would confirm all uses
    of cookies, web beacons, or other tracking technology by our third party advertisers and providers.</p>
<div class="page-title">How We Use Information.</div>
<p>
    <strong>Non-Personal Information.</strong>
    We may use and share any Non-Personal Information we collect through the Platform for any lawful business purpose
    without any duty or obligation of accounting or otherwise to you, provided that the Information remains Non-Personal
    Information. This will include, by way of example, providing Non-Personal Information to third parties, developing
    products, services or other offerings based on Non-Personal Information, or research and analysis of Non-Personal
    Information.
</p>
<p>
    <strong>Personal Information.</strong>
    We may use the Personal Information we collect about you through the Platform for a variety of purposes, for
    example:</p>
<ul>
    <li>Operating and providing Services through the Platform;</li>
    <li>Customizing and improving the Services and Platform for you;</li>
    <li>Providing maintenance, support, training and service for the Services and Platform;</li>
    <li>Providing notices, announcements and other communications to you relating to rGuest, the Platform, or your
        Information;</li>
    <li>Providing offers for products, services or other offerings to you that we feel may be of interest to you and
        enabling third parties that we feel may have products, services or other offerings of interest to you to contact
        you as well;</li>
    <li>Contacting you for direct marketing purposes regarding products, services and other offerings;</li>
    <li>Processing payments made through the Platform;</li>
    <li>Developing additional products, services and offerings; and</li>
    <li>Research and analysis purposes.</li>
</ul>

<p>We may combine and enhance the Personal Information we collect about you through the Platform with Information we
    receive from third parties. We may also combine and enhance Personal Information using Non-Personal Information. In
    each case, we will treat the combined Information as Personal Information and use it in accordance with this Policy.
</p>
<p>We may also use the Personal Information we collect about you through the Platform to generate Non-Personal
    Information. When we do so, we will take reasonable measures to ensure that the Non-Personal Information is no
    longer personally identifiable and may not later be reasonably associated with, linked to, or used to identify you.
    This will include, by way of example, storing the Non-Personal Information separately from any Personal Information.
    Once we generate Non-Personal Information from any Personal Information, we will not attempt to again make that
    Information into Personal Information (i.e., to make it personally identifiable). However, we may combine and
    enhance that Non-Personal Information with other Non-Personal Information (including Non-Personal Information we
    obtain third parties) and use the Non-Personal Information in accordance with this Policy.</p>
<p style='text-transform: uppercase;'>You should not provide any personal information THROUGH the Platform unless you
    agree to the use of that information in accordance with this Policy.</p>
<p>
    <strong>Sensitive Personal Information.</strong>
    We may receive Sensitive Personal Information from you when you agree to provide it to us through the Platform. For
    example, when you provide us with credit card or other payment or financial information, allow us to obtain and use
    your precise geo-location, or choose to share other Sensitive Personal Information in communications with us. rGuest
    will use any Sensitive Personal Information about you that we receive through the Platform solely in accordance with
    this Policy to enable the operation of the Platform, the performance of our Services for you, and the exchange of
    that Information as directed by you. Note though that rGuest is not responsible for monitoring the Sensitive
    Personal Information you choose to exchange with other Users or third parties through the Platform or for the use of
    that Information by those other Users or third parties.
</p>
<div class="page-title">How We Share Information.</div>
<p>We may share Information about you in a variety of ways, for example:</p>
<p>
    <strong>Affiliates, Subsidiaries, and Business Units.</strong>
    We may share Information about you with our affiliates and subsidiaries, regardless of whether these entities share
    the rGuest brand. We may also share Information about you with other business units that also offer websites,
    applications, or services under the rGuest brand or one of our other brands. We will require that our affiliates,
    subsidiaries and business units agree to use the Information we share with them in compliance with this Policy.
</p>
<p>
    <strong>Users and Social Sharing.</strong>
    We may share Information with other Users when you decide to interact and socialize with those Users (or request
    that we communicate on your behalf) through the Platform. This may include facilitating communications with other
    Users or enabling posting of Information to areas of the Platform accessible by other Users.
</p>
<p>
    <strong>Customers.</strong>
    We may share Information with our Customers. For example, when you make a reservation with one of our Customers
    through the Platform.
</p>
<p>
    <strong>Business Partners.</strong>
    We may share Information with business partners for which we collect Information through the Platform. We will work
    with our business partners to provide notice concerning the purpose for which any Personal Information is being
    collected on behalf of any partner. Unless we otherwise notify you, any information we collect on behalf of a
    business partner will be in accordance with this Policy.
</p>
<p>
    <strong>Service Providers.</strong>
    We may share Information we collect about you with third parties that help us provide any portion of the Platform.
    For example, we may use third parties to: (a) design, develop, host, maintain, or manage the Platform; (b) provide
    us with content for the Platform; (c) assist us with providing emails, text messages or other communications to you;
    (d) analyze Information; (e) host or manage our databases; (f) develop or offer additional products, services or
    offerings; or (g) provide other services to us relating to the Platform on an outsourced basis, for example, payment
    processing or identity validation. We require that these third parties agree to use the Information we share with
    them only to perform their obligations to us and to treat all Personal Information they receive from us in
    compliance with this Policy.
</p>
<p>
    <strong>Law Enforcement.</strong>
    We may share Information with law enforcement agencies if we reasonably believe unlawful activities have occurred or
    the Information may aid in an ongoing investigation. We may also share Information with law enforcement if we
    determine, in our sole judgment, that you have violated our agreements or policies or that the release of your
    Information may protect the rights, property, interests, or safety of rGuest or any third party.
</p>
<p>
    <strong>Legal Processes.</strong>
    We may share Information as required by, or permitted by, law, whether in response to subpoenas, court orders, other
    legal processes, or as we believe necessary to exercise our legal rights, including to defend against potential or
    actual legal claims brought against us.
</p>
<p>
    <strong>Business Transactions.</strong>
    If we transfer ownership or control of any portion of Agilysys Reserve or the Platform to a third party, whether or not
    in the context of an acquisition, merger, or reorganization, we may transfer Information that third party, provided
    that the use of any of your Personal Information by that third party remains subject to the terms of this Policy.
</p>
<div class="page-title">Choice and Opt-out.</div>
<p>We provide you with a choice whether to receive certain messages through the Platform and from rGuest. We also may
    give you the opportunity to “opt-out” of having your Personal Information shared for certain purposes permitted by
    this Policy.</p>
<p>If you no longer wish to receive certain messages from rGuest or to have your Personal Information shared by rGuest
    in the manner permitted by this Policy, you may seek to opt-out of receiving those messages or having your Personal
    Information shared in that manner. In some cases, messages and sharing of certain Information are necessary to the
    operation of the Platform. If you wish to opt-out of receiving these messages or of sharing your Personal
    Information in this manner, rGuest may be required to limit or cancel your access to the Platform.</p>
<p>All opt-out requests made to rGuest can be made as indicated through the Platform or contacting rGuest as described
    above. Note that it may take up to 10 business days for rGuest to remove contact information from our lists, so
    messages from us may continue for a time after a removal request is made.</p>
<div class="page-title">Security.</div>
<p>rGuest understands that the security of your Personal Information is important and is committed to protect and secure
    your Personal Information. Despite our commitment, no security system can be 100% effective and we cannot guarantee
    that your Information will be secure in all situations. We will nonetheless take all reasonable and appropriate
    steps to insure the safety and security of your Personal Information. This includes using industry standard security
    measures to protect the loss, misuse, and unintended alteration of the Personal Information under our control. For
    example, our policy is that only those individuals who need your Personal Information to perform a specific job for
    us are granted access to that Personal Information. Likewise, all employees and contractors are kept up-to-date on
    our security and privacy practices. Finally, the servers that we store personally identifiable information on are
    kept in a secure environment.</p>
<div class="page-title">Additional Terms.</div>
<p>
    <strong>Children.</strong>
    The Platform is intended for use only by individuals 18 years of age and older and thus is not directed to children
    under 13 years of age. rGuest does not knowingly solicit or collect personal information from children under 13
    years of age.
</p>
<p>
    <strong>Do Not Track.</strong>
    Certain web browsers and other devices you may use to access the Platform may permit you to indicate your preference
    that you do not wish to be “tracked” online. At this time we do not modify your experience on the Platform, or
    modify the Information we collect from you through the Site or Platform, based on whether such a preference is
    indicated.
</p>
<p>
    <strong>Review and Update of Information.</strong>
    While rGuest takes reasonable steps to ensure that the Personal Information we collect from you through the Platform
    is reliable for its intended use, accurate, complete, and current, we rely on you to update and correct your
    Personal information. Please contact us as described above to review, update, or change any of your Personal
    information collected through the Platform.
</p>
<p>
    <strong>Your California Privacy Rights.</strong>
    California law provides that California residents have a right to request that businesses tell them how their
    personal information has been shared with third parties for use in direct marketing purposes. There is an exception
    to this requirement for businesses that have adopted and disclosed, in their privacy policy, a policy of not
    disclosing a person’s Personal Information to third parties for use in direct marketing purposes if that person has
    exercised an option to opt-out of the disclosure of their Personal Information to third parties for such purposes.
    We have adopted a policy of allowing you to opt-out of the disclosure of your Personal Information to third parties
    for direct marketing purposes and thus fall within this exception. Instructions for opting out can be found in the
    section of this Policy entitled “Choice and Opt-Out.”
</p>
<p>
    <strong>Notification of Changes.</strong>
    We may notify you of any changes to this Policy by way of an email or by posting on the Platform. Changes to this
    Policy will be effective 30 days following such notice. Your continued use of the Platform after any change has
    become effective will constitute your acceptance of that change. Unless we seek and receive consent from you, we
    will use the Personal Information about you we collect through the Platform in accordance with the version of this
    Policy effective when the Personal Information was last collected.
</p>
<p>Revision Date: September 9, 2014</p>
</div>

</div>